import React, { useState } from 'react';
import styles from '../styles/styles.module.css';
import { useDispatch, useSelector } from 'react-redux';

import ModalSmall from '../../../components/ModalSmall/ModalSmall';
import { deleteUser } from '../../../api/user/post';
import { removeUser } from '../../../Redux/slices/allUsers';
import ProtectorCard from '../../../components/ProtectorCard/ProtectorCard';

export const Users: React.FC = () => {
  // useSelector((state) => console.log(state));
  const { users } = useSelector((state: any) => state.allUsers);
  const { assignedSites, userType } = useSelector((state: any) => state.user);
  const { sitePermissions, companyPermissions } = useSelector(
    (state: any) => state.user
  );
  const [currentlyDeleting, setCurrentlyDeleting] = useState<number[]>([]);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [deleteId, setDeleteId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  function filterUsers(): any[] {
    if (userType === 'HYPER_ADMIN' || userType === 'COMPANY_ADMIN') {
      return users;
    } else {
      if (companyPermissions.viewUsers) {
        return users;
      }

      if (sitePermissions.viewUsers) {
        const filtered = users.filter((usr: any) => {
          return usr.assignedSites?.some((ste: any) =>
            assignedSites.includes(ste.id)
          );
        });
        return filtered;
      } else {
        return [];
      }
    }
  }

  // const stageForDelete = (id: string, index: number) => {
  //   setDeleteId(id);
  //   setDeleteIndex(index);
  //   setCurrentlyDeleting((prev) => [...prev, index]);
  // };

  const handleCancel = () => {
    setDeleteId('');
    setDeleteIndex(null);
    setCurrentlyDeleting((prev) => prev.filter((i) => i !== deleteIndex));
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const res = await deleteUser(deleteId);

      if (res?.success) {
        dispatch(removeUser(res.data._id));
        setDeleteId('');
        setDeleteIndex(null);
        setCurrentlyDeleting((prev) => prev.filter((i) => i !== deleteIndex));
      }
    } catch (err) {
      console.error('Failed to delete user:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.sitesWrapper}>
      {filterUsers().map((user: any, index: number) => {
        return (
          <ProtectorCard
            key={index}
            userId={user._id}
            dlExpiration={'11/24/2026'}
            dlNumber={'F4753553'}
            ccwExpiration={'04/15/2027'}
            ccwNumber={'032981247'}
            faCardTitle={'Armed Security Permit'}
            faCardExp={'10/31/2026'}
            faCardNumber={'FQ3453455'}
            guardCardNumber={'G954353'}
            guardCardExp={'10/31/2026'}
            guardCardTitle={'Security Guard Permit'}
            hireDate={'12/25/2024'}
            status={'ACTIVE'}
            firstName={user.firstName}
            lastName={user.lastName}
          />
        );
      })}

      {currentlyDeleting.length > 0 && (
        <ModalSmall
          submitButtonText="Delete Anyway"
          title="Warning"
          text="Deleting this user will remove their access to all services."
          loading={isLoading}
          submitHandler={handleDelete}
          cancelHandler={handleCancel}
        />
      )}
    </div>
  );
};

export default Users;
